import {sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {DeactivateIosScrollAct} from '@gongxigames/framework/slotV2/ui/acts/DeactivateIosScrollAct';
import {ActivateIosScrollAct} from '@gongxigames/framework/slotV2/ui/acts/ActivateIosScrollAct';
import {AutoplayDisabledUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayDisabledUIAct';
import {AutoplayCheckNextSpinUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayCheckNextSpinUIAct';

export class AutoplayDisabledUIState extends UIState {
    public static readonly ID = 'AutoplayDisabledUIState';

    public setAct(): void {
        this.act = sequence([
            DeactivateIosScrollAct,
            AutoplayDisabledUIAct,
            AutoplayCheckNextSpinUIAct,
            ActivateIosScrollAct
        ]);
    }

    public canExecute(): boolean {
        return slotStore.isAutoplay.value && slotStore.isDisabledUIMode.value;
    }
}